import React, { useState } from 'react'
import { Link, Route, Routes, useLocation } from 'react-router-dom'
import './navbar.css'
import Home from '../Home/home'
import Service from '../Service/service'
import About from '../about/about'
import Contact from '../contact/contact'
import Projects from '../Projects/Projects'
import Certifications from '../Certifications/Certifications'

const Navbar = () => {
    const [bar,setBar] = useState(true)
    const location = useLocation().pathname
    
    let side = () => {
        if(bar===true) {
            setBar(false)
        }else if(bar===false) {
            setBar(true)
        }
    }
    
  return (
    <>
        <div className="navbar">
        <h1 className='logo'>Portfolio</h1>
        <div className="nav-links">
        <Link  id={location==='/My-React-Portfolio/'?"nav-click":null} className='nav-link' to='/My-React-Portfolio/'>Home</Link>
        <Link id={location==='/about'?"nav-click":null} className='nav-link' to='about'>About</Link>
        <Link id={location==='/service'?"nav-click":null} className='nav-link' to='service'>service</Link>
        <Link id={location==='/projects'?"nav-click":null} className='nav-link' to='projects'>Projects</Link>
        <Link id={location==='/certifications'?"nav-click":null} className='nav-link' to='certifications'>Certifications</Link>
        <Link id={location==='/contact'?"nav-click":null} className='nav-link' to='contact'>Contact</Link>
        </div>
        <div className="sidebarLogo">
        <i className="fa-solid fa-bars" onClick={()=>{side()}}></i>
        </div>
        </div>
        {bar===true?null:
        <div className="sidebar">
            <ul className='side'>
                <li className='list-links'><Link id={location==='/My-React-Portfolio/'?"nav-click":null} className='side-link' to='/My-React-Portfolio/' onClick={()=>{
                    setBar(true)
                }}>Home</Link></li>
                <li className='list-links'><Link id={location==='/about'?"nav-click":null} className='side-link' to='about' onClick={()=>{ 
                    setBar(true)
                }}>About</Link></li>
                <li className='list-links'><Link id={location==='/service'?"nav-click":null} className='side-link' to='service' onClick={()=>{ 
                    setBar(true)
                }}>service</Link></li>
                <li className='list-links'><Link id={location==='/projects'?"nav-click":null} className='side-link' to='projects' onClick={()=>{setBar(true)}}>Projects</Link></li>
                <li className='list-links'><Link id={location==='/certifications'?"nav-click":null} className='side-link' to='certifications' onClick={()=>{setBar(true)}}>Certifications</Link></li>
                <li className='list-links'><Link id={location==='/contact'?"nav-click":null} className='side-link' to='contact' onClick={()=>{setBar(true)}}>Contact</Link></li>
            </ul>
        </div>}



        <Routes>
            <Route path='/My-React-Portfolio/' element = {<Home/>} />
            <Route path='service' element = {<Service />} />
            <Route path='about' element = {<About />} />
            <Route path='contact' element = {<Contact />} />
            <Route path='projects' element = {<Projects/>} />
            <Route path='certifications' element = {<Certifications/>} />
            <Route path='/My-React-portfolio/contact' element = {<Contact />} />
        </Routes>
    </>
  )
}


export default Navbar
